import axios from "axios";

const NoResponse = (err) => {
    return {
        status: "false",
        message: "Hmm... Ocorreu um problema",
        title: "Ops..."
    };
};

const Backend = {
    // baseURL: "http://localhost:9001",
    baseURL: "https://posto011.com.br/wp-content/reactpress/apps/agendamento-v2/api",
    async call(route, data) {
        let contents = {
            headers: {
                "Content-Type": "application/json",
            },
        };
        const fetchRoute = this.baseURL + this.fixRoute(route);
        if (typeof data !== "undefined" && data !== null && data !== false) {
            contents['body'] = JSON.stringify(data);
            return axios
                .post(fetchRoute, data, contents)
                .then((response) => {
                    if (response.status !== 200) {
                        console.log(response);
                        return response;
                    }
                    return response.data;
                })
                .catch((error) => {
                    console.log("Error: ", error);
                    return NoResponse(error)
                });
        }
        return axios
            .get(fetchRoute, contents)
            .then((response) => {
                return response.data;
            })
            .catch((error) => {
                console.log("Error: ", error);
                return NoResponse(error);
            });
    },
    fixRoute(route) {
        if (route.slice(-1) !== "/") {
            return (route);
        }
        return route;
    }
};

export default Backend;
